module.exports = __webpack_public_path__ + "static/media/Grimer_gaussian2.0ab26fe6.png";